import xhttp from 'src/utils/xhttp'

const product = {
    list() {
        return xhttp.get('/api/dev/application/list')
    },

    detail(productId) {
        return xhttp.get(`/api/dev/application/detail/${productId}`)
    },

    /**
     * @param productId
     * @param name
     * @param remark
     */
    update(params) {
        return xhttp.post('/api/dev/application/update', params)
    },

    /**
     * @param name
     * @param remark
     */
    add(params) {
        return xhttp.post('/api/dev/application/add', params)
    },

    delete(productId) {
        return xhttp.get(`/api/dev/application/delete/${productId}`)
    },

    /**
     * 凭据列表
     *
     * @param page
     * @param pageSize
     * @param keyword
     * @param productId
     */
    credList({ productId, page = 1, pageSize = 10, keyword = '' }) {
        const params = {
            page,
            keyword,
            app_id: productId,
            page_size: pageSize
        }
        return xhttp.get('/api/dev/app-cred/list', { params })
    },

    /**
     * 添加凭据
     *
     * @param name
     * @param type
     * @param content
     * @param remark
     * @param productId
     */
    addCred(item) {
        const { productId: app_id, ...other } = item
        const params = {
            ...other,
            app_id
        }
        return xhttp.post('/api/dev/app-cred/add', params)
    },

    /**
     * 删除凭据
     *
     * @param productId
     */
    deleteCred(productId) {
        return xhttp.get(`/api/dev/app-cred/delete/${productId}`)
    },

    /**
     * 更新凭据
     *
     * @param name
     * @param type
     * @param content
     * @param remark
     * @param productId
     */
    updateCred(params) {
        return xhttp.post('/api/dev/app-cred/update', params)
    }
}

export default product
